export default __webpack_public_path__ + "static/media/houseIcon.be1a63d9.svg";